import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * Per-sighting GFW fishing-vessel breakdown. Backend lazily writes
 * the table from the FishingEffortService cron, so sightings that
 * haven't been processed yet are silently absent from the response.
 */
export class SightingFishingVessel {
    /**
     * Bulk-fetch vessels for a set of sighting ids. Empty input
     * returns an empty list without an HTTP call.
     */
    static async getList(sightingIds) {
        var _a;
        if (sightingIds.length === 0) {
            return [];
        }
        const req = { sighting_ids: sightingIds };
        const result = await NetFetch.postData('/json/sightings/fishing-vessels/list', req);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = (result.list)) !== null && _a !== void 0 ? _a : [];
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return [];
    }
}
